//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configStore from '@/store/modules/configStore';
import customerStore from '@/store/modules/customerStore';
import IntroDialog from '@/components/upload/dialogs/IntroDialog';
import { Loading } from 'quasar';

export default {
    data() {
        return {
            menu: null,
        };
    },
    computed: {
        showLogo() {
            return !this.$route.meta?.hideLogo;
        },
        showMenu() {
            return !this.$route.meta?.hideMenu;
        },
        documentRoute() {
            const enquiries = (this?.customer?.enquiries || []).filter(enq => enq.status !== 'draft');
            if (enquiries.length === 1) {
                return { name: 'customer-enquiry', params: { id: enquiries[0].id } };
            }

            return { name: 'customer-hub' };
        },
        ...configStore.mapState({
            config: configStore.STATE.CONFIG,
        }),
        ...customerStore.mapState({
            loggedInCustomer: customerStore.STATE.LOGGED_IN_CUSTOMER,
        }),
        ...customerStore.mapGetters({
            isLoggedIn: customerStore.GETTERS.IS_LOGGED_IN,
            loggedInCustomerLoaded: customerStore.GETTERS.LOGGED_IN_CUSTOMER_LOADED,
            customerHasRole: customerStore.GETTERS.HAS_ROLE,
        }),
        ...customerStore.mapState({
            customer: customerStore.STATE.LOGGED_IN_CUSTOMER,
        }),
    },
    methods: {
        intro() {
            const menu = this.menu;
            this.$nextTick(() => {
                this.menu = menu;
            });
            this.$q.dialog({
                component: IntroDialog,
                parent: this,
            });
        },
        async logout() {
            Loading.show();
            await customerStore.dispatch(customerStore.ACTIONS.LOGOUT);
            Loading.hide();
            await this.$router.push({ name: 'customer-login' });
        },
    },
};
